import { Bin, BinStatus } from '.';
import { ProductTransaction } from '../productTransaction';

export namespace BinUtil {
  export function isValidDestination({
    transaction,
    bin,
    binStatuses,
  }: {
    transaction?: ProductTransaction;
    bin: Bin;
    binStatuses: Map<string, BinStatus>;
  }): boolean {
    if (transaction?.product.toStockLocationId && bin.stockLocationId !== transaction.product.toStockLocationId) {
      return false;
    }

    const binStatus = binStatuses.get(bin.id);
    if (!binStatus) return true;

    return binStatus.inboundAllowed || true;
  }

  export function isValidSource({
    transaction,
    bin,
    binStatuses,
  }: {
    transaction?: ProductTransaction;
    bin: Bin;
    binStatuses: Map<string, BinStatus>;
  }): boolean {
    if (transaction?.product.fromStockLocationId && bin.stockLocationId !== transaction.product.fromStockLocationId) {
      return false;
    }

    const binStatus = binStatuses.get(bin.id);
    if (!binStatus) return true;

    return binStatus.outboundAllowed || true;
  }
}
